import React from "react";
import {
  ComponentType,
  questionPresentationContent
} from "../../data/QuestionPresentation";
import { RadioAndSelectQuestionCompact } from "./components/RadioAndSelectQuestionCompact";
import { RadioAndToolTipQuestionCompact } from "./components/RadioAndToolTipQuestionCompact";
import { RadioAndCheckboxQuestionCompact } from "./components/RadioAndCheckboxQuestionCompact";

interface ConditionQuestionProps {
  question: Question;
  storedAnswer: ChosenAnswer;
  subtitle: string;
  isContinueClicked: boolean;
}

export default function ConditionQuestionCompactView({
  question,
  storedAnswer,
  subtitle,
  isContinueClicked
}: ConditionQuestionProps) {
  const { id } = question;

  return (
    <>
      <hr className="ch-bg--grey-3 review-divider" />
      {questionPresentationContent[id]?.component?.type ===
      ComponentType.RADIOANDSELECT ? (
        <div className="ch-form__group ch-pt--4 ch-pb--6">
          {subtitle && <h3 className="ch-text--normal ch-pb--3">{subtitle}</h3>}
          <RadioAndSelectQuestionCompact question={question} />
        </div>
      ) : questionPresentationContent[id]?.component?.type ===
        ComponentType.RADIOWITHTOOTIP ? (
        <div className="ch-form__group ch-pt--4 ch-pb--6">
          {subtitle && <h3 className="ch-text--normal ch-pb--3">{subtitle}</h3>}
          <RadioAndToolTipQuestionCompact question={question} />
        </div>
      ) : (
        <div className="ch-form__group ch-pt--4 ch-pb--6">
          {subtitle && <h3 className="ch-text--normal ch-pb--3">{subtitle}</h3>}
          <RadioAndCheckboxQuestionCompact question={question} />
        </div>
      )}
    </>
  );
}
